import React, { useState, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';

const ResultsSearchContext = React.createContext({
  resultsSearchExpanded: false,
  setResultsSearchExpanded: () => {},
  resultsCategory: 'VENUE',
  setResultsCategory: () => {},
});

export function MobileResultsSearchProvider({ children }) {
  const [resultsSearchExpanded, setResultsSearchExpanded] = useState(false);
  const [resultsCategory, setResultsCategory] = useState('VENUE');

  const value = useMemo(
    () => ({
      resultsSearchExpanded,
      setResultsSearchExpanded,
      resultsCategory,
      setResultsCategory,
    }),
    [resultsSearchExpanded, resultsCategory],
  );

  return (
    <ResultsSearchContext.Provider value={value}>
      {children}
    </ResultsSearchContext.Provider>
  );
}

MobileResultsSearchProvider.propTypes = {
  children: PropTypes.node,
};

export function useResultsSearchContext() {
  return useContext(ResultsSearchContext);
}
